<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="basic"
    viewBox="0 0 48 48"
  >
    <path fill="#4fc3f7" d="M45,8H3v32h42V8z" />
    <circle cx="16" cy="21" r="8" fill="#1565c0" />
    <path
      fill="#ff8f00"
      d="M16,21l0-9c2.387,0.001,4.677,0.949,6.364,2.636S25,18.613,25,21L16,21z"
    />
    <path fill="#1565c0" d="M39,36H24l-1-1l1-1h15V36z" />
    <path fill="#ff8f00" d="M24,34v2H9v-2H24z" />
    <path
      fill="#ff8f00"
      d="M37.5,16h-6c-0.828,0-1.5-0.672-1.5-1.5l0,0c0-0.828,0.672-1.5,1.5-1.5h6c0.828,0,1.5,0.672,1.5,1.5   l0,0C39,15.328,38.328,16,37.5,16z"
    />
    <path
      fill="#1565c0"
      d="M37.5,22h-6c-0.828,0-1.5-0.672-1.5-1.5l0,0c0-0.828,0.672-1.5,1.5-1.5h6c0.828,0,1.5,0.672,1.5,1.5    l0,0C39,21.328,38.328,22,37.5,22z"
    />
    <path
      fill="#1565c0"
      d="M37.5,28h-6c-0.828,0-1.5-0.672-1.5-1.5l0,0c0-0.828,0.672-1.5,1.5-1.5h6c0.828,0,1.5,0.672,1.5,1.5    l0,0C39,27.328,38.328,28,37.5,28z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ControlPanelIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
